import { motion } from "framer-motion";
import {
  FaUsers,
  FaFileContract,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaIdCard,
  FaSitemap,
} from "react-icons/fa";

import styles from "../styles_about/CompanySnapshot.module.css";

const companyDetails = [
  {
    label: "Company Name",
    value: "VishvaConnect Technologies LLP",
    icon: FaUsers,
  },
  {
    label: "GST No.",
    value: "27ABAFV3540M1ZX",
    icon: FaFileContract,
  },
  {
    label: "Incorporation Date",
    value: "06 June 2025",
    icon: FaCalendarAlt,
  },
  {
    label: "Registered Address",
    value: "Ahilyanagar, Maharashtra, India",
    icon: FaMapMarkerAlt,
  },
  {
    label: "PAN",
    value: "ABAFV3540M",
    icon: FaIdCard,
  },
  {
    label: "Industry",
    value: "IT Services & Software Development",
    icon: FaSitemap,
  },
];

export default function CompanySnapshot() {
  return (
    <section className={styles.snapshotSection}>
      <div className={styles.snapshotContainer}>
        {/* Left side company information */}
        <motion.div
          className={styles.snapshotContent}
          initial={{ opacity: 0, x: -35 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <h2 className={styles.sectionTitle}>Company Snapshot</h2>
          <div className={styles.titleDecoration}>
            <span />
            <span />
          </div>

          <p className={styles.sectionDescription}>
            VishvaConnect Technologies LLP is a software development company
            delivering innovative digital solutions for government
            organizations, enterprises and businesses worldwide.
          </p>

          <div className={styles.detailsList}>
            {companyDetails.map((detail, index) => {
              const Icon = detail.icon;

              return (
                <motion.div
                  className={styles.detailItem}
                  key={detail.label}
                  initial={{ opacity: 0, y: 18 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{
                    duration: 0.45,
                    delay: index * 0.08,
                  }}
                >
                  <div className={styles.detailIcon}>
                    <Icon />
                  </div>

                  <div className={styles.detailText}>
                    <h3>{detail.label}</h3>
                    <p>{detail.value}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </motion.div>

        {/* Right side office image */}
        <motion.div
          className={styles.snapshotVisual}
          initial={{ opacity: 0, x: 35 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <div className={styles.officeImageWrapper}>
            <img
              src="/recept_image.png"
              alt="VishvaConnect Technologies LLP office reception"
              className={styles.officeImage}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
